<template>
  <div>
    <img src="../assets/my/2026.png" style="height:120px;"/>
    	<div id="wrapper">
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Registration
    				</strong>
    			</p>

    			
             <p>Online registration information will be available from the <a href="https://www3.cs.stonybrook.edu/~bibm2026/">BIBM 2026 main conference website</a>.</p>
    		</div>
    	</div>
      <footer-component></footer-component>
      
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
